import { apiClient, type Paginated } from '@/core/api';
import type { ExpenseEntry, IncomeEntry } from './types';

export const INCOME_BASE = '/finance/income/';
export const EXPENSE_BASE = '/finance/expenses/';

export interface IncomeListParams {
  page?: number;
  search?: string;
  /** DRF `OrderingFilter` value, e.g. `date` or `-base_amount`. */
  ordering?: string;
  /** Inclusive date-range bounds (`YYYY-MM-DD`) on the entry date. */
  after?: string;
  before?: string;
}

export interface ExpenseListParams {
  page?: number;
  search?: string;
  /** DRF `OrderingFilter` value, e.g. `date` or `-base_amount`. */
  ordering?: string;
  /** Attribute to one employee (recurring per-employee costs). */
  employee?: number;
  category?: string;
  /** `true` → only rows generated from a recurring template. */
  recurring?: boolean;
  /** Inclusive date-range bounds (`YYYY-MM-DD`) on the entry date. */
  after?: string;
  before?: string;
}

export async function listIncome(params: IncomeListParams = {}): Promise<Paginated<IncomeEntry>> {
  const { data } = await apiClient.get<Paginated<IncomeEntry>>(INCOME_BASE, { params });
  return data;
}

export async function listExpenses(
  params: ExpenseListParams = {},
): Promise<Paginated<ExpenseEntry>> {
  const { data } = await apiClient.get<Paginated<ExpenseEntry>>(EXPENSE_BASE, { params });
  return data;
}
